import { UnderlineContainer, Underline } from './styles';

interface UnderlineProps {
  width: string;
  color: string;
  height?: string;
  justify?: string;
  paddingLeft?: string;
  paddingRight?: string;
}

const UnderLine = ({
  width,
  color,
  justify,
  height,
  paddingLeft,
  paddingRight,
}: UnderlineProps) => {
  return (
    <UnderlineContainer
      justify={justify}
      paddingLeft={paddingLeft}
      paddingRight={paddingRight}
    >
      <Underline width={width} color={color} height={height} />
    </UnderlineContainer>
  );
};

export default UnderLine;
